<template>
  <div
    class="relative overflow-hidden rounded-lg border border-blue bg-white pr-16"
    @click="focusInput"
  >
    <label
      class="block flex w-full flex-grow items-center px-6 py-5 leading-none"
    >
      <input
        ref="input"
        v-model.trim="valueLocal"
        class="h-[22px] w-full flex-grow border-0 text-md text-slate transition placeholder:text-slate-lighten4 focus:border-0 focus:outline-none"
        :placeholder="placeholder"
        style="box-shadow: none"
      />
    </label>

    <UiButton
      block
      absolute
      fit-height
      :rounded="false"
      class="bottom-0 right-0 top-0 ml-auto h-16 !w-16 flex-grow-0 items-center"
      @click="search"
      @keydown.enter.prevent="search"
    >
      <UiIcon icon="search" class="text-white" />
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';

interface Props {
  modelValue?: string | null;
}
interface Emits {
  (e: 'search' | 'update:modelValue', data: Props['modelValue']): void;
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
});

const emit = defineEmits<Emits>();

const { t } = useI18n();

const input = ref();
const placeholder = t('search_placeholder');
const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});

const focusInput = () => input.value.focus();

const search = () => {
  emit('search', valueLocal.value);
};

onMounted(() => {
  focusInput();
});
</script>
